import type { ReactNode } from 'react';

export enum Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export enum OverviewTab {
  Ratings = 'ratings',
  Journals = 'journals',
  Attendance = 'attendance',
  Report = 'report',
}

export enum EvaluationMode {
  Average = 'average',
  Final = 'final',
}

export enum Season {
  Winter = 'winter',
  Spring = 'spring',
  Summer = 'summer',
  Autumn = 'autumn',
}

export enum ScheduledTestsItemType {
  SeasonHeader = 'season-header',
  MonthHeader = 'month-header',
  DayHeader = 'day-header',
  Test = 'test',
  EmptyMonth = 'empty-month',
}

export enum ProfileMenuView {
  Menu = 'menu',
  Username = 'username',
  Phone = 'phone',
  Email = 'email',
  Password = 'password',
  Family = 'family',
  Notifications = 'notifications',
}

export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
}

export enum ButtonType {
  Button = 'button',
  Submit = 'submit',
}

export enum ModalSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  XLarge = 'xLarge',
}

export enum ModalVariant {
  Default = 'default',
  BottomSheet = 'bottom-sheet',
}

export enum BorderRadius {
  Small = 'small',
  Medium = 'medium',
  Pill = 'pill',
}

export enum SnackbarVariant {
  Success = 'success',
  Error = 'error',
}

export enum SpinnerColor {
  Grey = 'grey',
  Blue = 'blue',
}

export enum AnimationState {
  Enter = 'enter',
  Shown = 'shown',
  Exit = 'exit',
}

export enum IconType {
  Logout = 'logout',
  PlusSign = 'plus-sign',
  Close = 'close',
  ArrowLeft = 'arrow-left',
  Return = 'return',
  ChevronRight = 'chevron-right',
  ChevronDown = 'chevron-down',
  CheckCircle = 'check-circle',
  Alert = 'alert',
  Support = 'support',
  Chat = 'chat',
  Mother = 'mother',
  Father = 'father',
  Student = 'student',
  Person = 'person',
  Phone = 'phone',
  Mail = 'mail',
  Lock = 'lock',
  Group = 'group',
  Bell = 'bell',
  BellRinging = 'bell-ringing',
  Subscription = 'subscription',
  Advertisement = 'advertisement',
  Partners = 'partners',
  Link = 'link',
  Help = 'help',
  ThemeLight = 'theme-light',
  ThemeDark = 'theme-dark',
  ThemeContrast = 'theme-contrast',
  ThemeSystem = 'theme-system',
}

export enum MailSection {
  Mail = 'mail',
  Surveys = 'surveys',
  VideoCalls = 'video-calls',
}

export enum MailFolderType {
  Inbox = 'standardType_fmft_inbox',
  Unread = 'standardType_fmft_unread',
  FollowUp = 'standardType_fmft_followUp',
  Deleted = 'standardType_fmft_deleted',
  Drafts = 'standardType_fmft_drafts',
  Sent = 'standardType_fmft_sent',
}

export enum MailFolderActionType {
  Refresh = 'type_mfa_refresh',
  Delete = 'type_mfa_delete',
  PermanentDelete = 'type_mfa_permanentDelete',
  MarkAsRead = 'type_mfa_markAsRead',
  MarkAllAsRead = 'type_mfa_markAllAsRead',
}

export enum MailSearchType {
  Author = 'standardType_mfst_author',
  Recipient = 'standardType_mfst_recipient',
  Subject = 'standardType_mfst_subject',
}

export enum FollowUpStatus {
  None = 'none',
  Marked = 'marked',
  Completed = 'compleated',
}

export enum MessageStatus {
  Unread = 'unread',
  Read = 'read',
  Replied = 'replied',
  Forwarded = 'forwarded',
}

export enum MessageRecipientStatus {
  Unread = 'unread',
  Read = 'read',
  Replied = 'replied',
  Forwarded = 'forwarded',
}

export enum AttachmentErrorKind {
  Oversize = 'oversize',
  InvalidType = 'invalidType',
  UploadFailed = 'uploadFailed',
}

export enum AttachmentUploadOrigin {
  Mail = 'mail',
  HomeTask = 'hometask',
}

export enum AttachmentUploadStatus {
  Ok = 'Ok',
  InvalidFileType = 'InvalidFileType',
  FileIsTooLarge = 'FileIsTooLarge',
  RequestFileNotFound = 'RequestFileNotFound',
  FileIsInfected = 'FileIsInfected',
  FileIsTooSmall = 'FileIsTooSmall',
}

export enum MailDraftType {
  New = 'mdt_new',
  Reply = 'mdt_reply',
  Forward = 'mdt_forward',
}

export enum MailComposeMode {
  New = 'new',
  Draft = 'draft',
  Reply = 'reply',
  Forward = 'forward',
}

export enum MailSubjectPrefix {
  None = '',
  Reply = 'RE: ',
  Forward = 'FWD: ',
}

export enum SurveyStatus {
  Active = 'ssid_Active',
  Finished = 'ssid_Finished',
  Deleted = 'ssid_Deleted',
  Draft = 'ssid_Draft',
  Inactive = 'ssid_Inactive',
}

export enum SurveyUserStatus {
  New = 'srid_New',
  Started = 'srid_Started',
  Finished = 'srid_Finished',
  Completed = 'srid_Completed',
  Deleted = 'srid_Deleted',
}

export enum SurveyDisplayStatus {
  ToFill = 'to-fill',
  Filled = 'filled',
  Closed = 'closed',
}

export enum SurveyAnonymity {
  Anonymous = 'srid_Anonymous',
  Personalized = 'srid_Personalized',
}

export enum SurveyResultsAccessType {
  Anonymized = 'srid_Anonymized',
  Forbidden = 'srid_Forbidden',
  Allowed = 'srid_Allowed',
}

export enum SurveyDetailState {
  New = 'new',
  Continue = 'continue',
  Restricted = 'restricted',
  Results = 'results',
}

export enum SurveyQuestionType {
  SingleAnswer = 'qtid_SingleAnswer',
  MultiAnswer = 'qtid_MultiAnswer',
  Feedback = 'qtid_Feedback',
  FreeForm = 'qtid_FreeForm',
}

export enum VideoMeetingGroup {
  Today = 'today',
  All = 'all',
}

export enum VideoMeetingType {
  Meeting = 'st_vmt_meeting',
  ParentTeacher = 'st_vmt_parentTeacherMeeting',
  Lesson = 'st_vmt_lesson',
  Individual = 'st_vmt_individualConversation',
  Other = 'st_vmt_other',
}

export enum VideoMeetingStatus {
  Active = 'active',
  Ended = 'ended',
  Deleted = 'deleted',
}

export enum VideoMeetingUserStatus {
  None = 'vmid_None',
  Confirmed = 'vmid_Confirmed',
  Declined = 'vmid_Declined',
  Pending = 'vmid_Pending',
  Canceled = 'vmid_Canceled',
  Deleted = 'vmid_Deleted',
}

export enum VideoMeetingDisplayStatus {
  Confirmed = 'confirmed',
  Pending = 'pending',
  Declined = 'declined',
  Canceled = 'canceled',
  Ended = 'ended',
}

export enum PreschoolCriterionType {
  MultiOption = 'MultiOption',
  Text = 'Text',
  Bool = 'Bool',
}

export enum PreschoolEvaluationOption {
  Yes = 'yes',
  No = 'no',
  Partially = 'partially',
}

export enum HeaderCardIcon {
  Absence = 'absence',
  News = 'news',
  Homework = 'homework',
  TestSchedule = 'test-schedule',
}

export enum DashboardTileType {
  Grades = 'grades',
  Diary = 'diary',
  Absences = 'absences',
}

export enum UnseenEventType {
  Evaluation = 'Evaluation',
  BehaviorEntry = 'BehaviorEntry',
  DiaryNote = 'DiaryNote',
  NonAttendance = 'NonAttendance',
  News = 'News',
}

export enum AbsenceResultChipKind {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export enum CheckoutDisclaimerType {
  Card = 'cardDisclaimer',
  Bank = 'bankDisclaimer',
}

export enum PaymentOptionType {
  Recurring = 'recurring',
  Year = 'year',
  Month = 'month',
  Sms = 'sms',
  NextYear = 'nextYear',
}

export enum PaymentMethod {
  Seb = 'seb_ob_lv',
  Swed = 'swed_ob_lv',
  Luminor = 'luminor_ob_lv',
  Citadele = 'citadele_ob_lv',
  Card = 'card',
}

export interface PaymentOption {
  type: PaymentOptionType;
  label: string;
  currentPrice: string;
  previousPrice?: string;
  pricePeriodDescription?: string;
  title: string;
  subtitle?: string;
  buttonLabel: string;
  paymentMethods: PaymentMethod[];
  recurringEndDate?: string;
  recurringMaxEndDate?: string;
}
export interface PaymentOptionResponse {
  type: PaymentOptionType;
  label: string;
  currentPrice: string;
  previousPrice?: string;
  pricePeriodDescription?: string;
  title: string;
  periodName?: string;
  description?: string;
  buttonLabel: string;
  paymentMethods: PaymentMethod[];
  recurringEndDate?: string;
  recurringMaxEndDate?: string;
}

export enum AttachmentsDisplay {
  Aggregated = 'aggregated',
  Expanded = 'expanded',
  Hidden = 'hidden',
}

export enum DiaryStepDirection {
  Forward = 'forward',
  Backward = 'backward',
}

export enum HomeTaskType {
  EKlase = 'eklase',
  Soma = 'soma',
  Uzdevumi = 'uzdevumi',
}

export interface IconComponentProps {
  className?: string;
  strokeWidth?: string;
}

export interface NavItem {
  to: string;
  label: string;
  icon: ReactNode;
  iconActive?: ReactNode;
  end?: boolean;
}

export enum LessonDetailsMode {
  Lesson = 'lesson',
  Evaluation = 'evaluation',
}

export enum ContactSupportFieldErrorId {
  Email = 'contact-support-email-error',
  Phone = 'contact-support-phone-error',
  Message = 'contact-support-message-error',
}
